import React, { useEffect, useState } from "react";
import "./AssessmentCrud.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faCopy,
  faEye,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
//import sortByAssessmentName from '../sortingHelper';

const config = require("../../config.js");

function ReportAssessment() {
  const { reportId } = useParams();
  const [assessments, setAssessments] = useState([]);
  const navigate = useNavigate();
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;

  const fetchAssessments = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/results/report/" + reportId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setAssessments(data);
      } else {
        console.error("Failed to fetch assessments");
      }
    } catch (error) {
      console.error("Error fetching assessments:", error);
    }
  };

  useEffect(() => {
    fetchAssessments(); // Fetch assessments on component mount
  }, []);

  const GotoViewAnswer = (result) => {
    navigate("/take-assessment", {
      state: {
        examName: result.examName,
        examCategory: result.examCategory,
        isMSS: result.isMSS,
        assessmentId: result.assessmentId._id,
        disabled: true,
        edit: true,
        resultId: result._id,
      },
    });
  };

  const GoBack = () => {
    window.history.back();
  }

  return (
    <>
    <div style={{cursor:"pointer", left: "30px", position: "absolute", top: "55px"}} onClick={() => GoBack()}>
                  <FontAwesomeIcon icon={faArrowLeftLong} />
                  <span style={{ marginLeft: "10px" }}>Back</span>
                </div>
      <div className="mt-5 Crud-main-container container">
        <table className="table Crud-main container">
          <thead>
            <tr className="Crud-thead-wrapper">
              {
                user.role != 'users' &&
                <>
                  <th scope="col">Company</th>
                  <th scope="col">Email</th>
                </> 
              }
              <th scope="col">Activity</th>
              <th scope="col">Category</th>
              <th scope="col">Language</th>
              <th scope="col">End</th>
              <th scope="col">Year</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {assessments
              .slice()
              //.sort(sortByAssessmentName)
              .map((assessment) => (
                <tr key={assessment._id}>
                   {
                    user.role != 'users' &&
                    <>
                      <td>{assessment.userId.companyName}</td>
                      <td>{assessment.userId.email}</td>
                    </>
                   }
                  <td>{assessment.examName}</td>
                  <td>{assessment.examCategory}</td>
                  <td>{assessment.assessmentId.language}</td>
                  <td>{assessment.end ? 'Yes' : 'No'}</td>
                  <td>{assessment.year}</td>
                  <td
                    className="view-exam-icon"
                    onClick={() =>
                      GotoViewAnswer(
                        assessment
                      )
                    }
                  >
                    <FontAwesomeIcon icon={faEye} /> View Answer
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReportAssessment;
